/** Canada-first km units — display fallbacks for legacy mi fields. */

const MI_TO_KM = 1.60934;
const KM_TO_MI = 1 / MI_TO_KM;

export const DEFAULT_INCLUDED_KM_PER_DAY = 320;
export const DEFAULT_OVERAGE_FEE_PER_KM = 0.16;

export function miToKm(mi) {
  if (mi == null) return null;
  return Math.round(Number(mi) * MI_TO_KM);
}

export function kmToMi(km) {
  if (km == null) return null;
  return Math.round(Number(km) * KM_TO_MI);
}

/** Included km/day and overage $/km from vehicle (legacy mi fields supported). */
export function vehicleKmPolicy(veh) {
  if (!veh) {
    return { includedKm: DEFAULT_INCLUDED_KM_PER_DAY, overageFeePerKm: DEFAULT_OVERAGE_FEE_PER_KM };
  }
  let includedKm;
  if (veh.included_km_per_day != null) {
    includedKm = Number(veh.included_km_per_day);
  } else if (veh.included_miles_per_day != null) {
    includedKm = miToKm(veh.included_miles_per_day) ?? DEFAULT_INCLUDED_KM_PER_DAY;
  } else {
    includedKm = DEFAULT_INCLUDED_KM_PER_DAY;
  }
  let overageFeePerKm;
  if (veh.overage_fee_per_km != null) {
    overageFeePerKm = Number(veh.overage_fee_per_km);
  } else if (veh.overage_fee_per_mile != null) {
    overageFeePerKm = Math.round(Number(veh.overage_fee_per_mile) * KM_TO_MI * 100) / 100;
  } else {
    overageFeePerKm = DEFAULT_OVERAGE_FEE_PER_KM;
  }
  return { includedKm, overageFeePerKm };
}

export function hasKmPolicy(veh) {
  return !!veh && (
    veh.included_km_per_day != null
    || veh.included_miles_per_day != null
    || veh.overage_fee_per_km != null
    || veh.overage_fee_per_mile != null
  );
}

export function formatKmPolicyLine(veh) {
  const { includedKm, overageFeePerKm } = vehicleKmPolicy(veh);
  return `${includedKm} km/day included · $${overageFeePerKm.toFixed(2)}/km overage`;
}

/** Prefer odometer_km; convert legacy odometer_mi for display. */
export function displayOdometerKm(record) {
  if (record?.odometer_km != null) return Number(record.odometer_km);
  if (record?.odometer_mi != null) return miToKm(record.odometer_mi);
  return null;
}
